import React from "react";
import { useTheme } from "../context/ThemeContext";
import { Sun, Moon } from "lucide-react";
import OpticPickerIcon from "./OpticPickerIcon";

const Navigation = ({ currentPage, setCurrentPage }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <nav className="bg-gray-900/95 backdrop-blur-sm border-b border-gray-700/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <div className="flex items-center gap-8 h-full">
            <button
              onClick={() => setCurrentPage("home")}
              className="flex items-center gap-3 text-white hover:text-blue-400 transition group h-full"
            >
              <div className="flex items-center justify-center h-full -mb-5">
                <OpticPickerIcon size={80} />
              </div>

              {/* --- FIXED SECTION --- */}
              <span className="text-2xl font-bold tracking-tight leading-none -mt-1 mb-1">
                OpticPicker
              </span>
              {/* --------------------- */}
            </button>

            <div className="hidden md:flex items-center gap-6 h-full -mt-0 mb-0">
              {["home", "browse", "compare", "about", "disclosure"].map(
                (id) => (
                  <button
                    key={id}
                    onClick={() => setCurrentPage(id)}
                    className={`text-sm font-medium transition capitalize ${
                      currentPage === id
                        ? "text-blue-400"
                        : "text-gray-300 hover:text-white"
                    }`}
                  >
                    {id}
                  </button>
                )
              )}
            </div>
          </div>

          <div className="flex items-center">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition text-white border border-gray-700 -mt-0 mb-0"
              aria-label="Toggle theme"
            >
              {isDark ? (
                <Sun className="w-5 h-5 text-yellow-400" />
              ) : (
                <Moon className="w-5 h-5 text-blue-400" />
              )}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
